import { action, computed, observable, toJS } from 'mobx';
import { looseEqual } from '@linktivity/link-utils';
import { allotmentApi } from '@link/supplier/services';
import { AllotmentSetting } from '@link/supplier/services/types';

export class Allotment {
  // original data source (set only once after API request)
  @observable accessor originalAllotment: AllotmentSetting | null = null;
  // modifiable copy
  @observable accessor allotment: AllotmentSetting | null = null;

  @action
  async getAlloment(poolId: string) {
    const allotment = await allotmentApi.getAllotmentSetting({
      body: { poolId }
    });
    if (allotment) {
      this.setAlloment(allotment);
    }
  }

  @action
  setAlloment(allotment: AllotmentSetting) {
    this.originalAllotment = allotment;
    this.allotment = allotment;
  }

  @action
  clearAlloment() {
    this.originalAllotment = null;
    this.allotment = null;
  }

  // Update a specific field in the allotment
  @action
  updateAllotment(updater: (allotment: AllotmentSetting) => void) {
    updater(this.allotment!);
  }
  @action
  resetAllotment() {
    this.allotment = JSON.parse(JSON.stringify(this.originalAllotment));
  }
  @computed
  get loaded(): boolean {
    return !!this.allotment?.poolId;
  }

  @computed
  get name() {
    return this.allotment?.name || '';
  }

  @computed
  get poolId() {
    return this.allotment?.poolId || '';
  }
  @computed
  get supplierId() {
    return this.allotment?.supplierId || '';
  }
  @computed
  get supplierInventoryId() {
    return this.allotment?.supplierInventoryId || '';
  }
  @computed
  get bundles() {
    return toJS(this.allotment?.bundles) || [];
  }

  @computed
  get otaSettings() {
    return toJS(this.allotment?.otaSettings) || [];
  }
  @computed
  get segments() {
    return toJS(this.allotment?.segments) || [];
  }
  @computed
  get calendarEdits() {
    return toJS(this.allotment?.calendarEdits) || [];
  }
  @computed
  get segmentRules() {
    return toJS(this.allotment?.segmentRules) || [];
  }
  @computed
  get dateSettings() {
    return toJS(this.allotment?.dateSettings) || [];
  }
  @computed
  get freesale() {
    return this.allotment?.freesale;
  }
  @computed
  get isBlocked() {
    return !looseEqual(this.originalAllotment, this.allotment);
  }
  @computed
  get originalName() {
    return this.originalAllotment?.name || '';
  }
  @computed
  get groupKeyOptions() {
    const groupKeys = [
      ...new Set(this.otaSettings?.map(({ groupKey = '' }) => groupKey))
    ];
    return groupKeys.map(groupKey => ({
      label: groupKey,
      value: groupKey
    }));
  }
}

export default new Allotment();
